import {Col, message, Row} from "antd";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {MSG_BANK_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR} from "../../../util/Messages";
import {AddressDto} from "../../../dto/AddressDto";
import BankAccountDetailsUpdateRequestListComp
    from "../../admin/customerRequestsList/bankAccountDetailsUpdateRequestsListComp";


interface BankDetailsChangeHistoryProp {
    cin: string
    handleTabChange: (activeKey: string) => void
}

const BankDetailsChangeHistoryComp = (props: BankDetailsChangeHistoryProp) => {
    const [isLoading, setLoading] = useState(false);
    const [addressDetailChangeHistoryList, setAddressDetailChangeHistoryList] = useState<AddressDto[]>()

    useEffect(() => {
        fetchBankDetailChangeHistory(props.cin)
    }, []);

    const fetchBankDetailChangeHistory = (cin: string) => {
        setLoading(true)
        customerChangeRequestService.getBankDetailChangeRequestHistory(cin).then((res) => {
            if (res.data.results) {
                console.log('bankHistry',res.data.results)
                setAddressDetailChangeHistoryList(res.data.results.pendingRequests)
                setLoading(false)
            } else {
                message.error(MSG_BANK_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }


    return (
        <>
            <Row gutter={[24, 12]}>

                <Col span={24}>
                    <BankAccountDetailsUpdateRequestListComp isFromHst={true}
                                                             bankDetailDtoList={addressDetailChangeHistoryList} handleTabChange={props.handleTabChange}/>
                </Col>
            </Row>

        </>
    )
}
export default BankDetailsChangeHistoryComp;